import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';

import sanitize from 'utils/sanitize';

export type OptionButtonOptionData = {
  id: number;
  image_url: string;
  name: string;
  tooltip_title: string;
};

export type OptionButtonProps = {
  option: OptionButtonOptionData;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: React.MouseEventHandler;
  disabledBy: string;
  onClickTooltip: (id: string) => void;
};

function OptionButton({
  isSelected,
  isDisabled,
  onClick,
  option,
  disabledBy,
  onClickTooltip,
}: OptionButtonProps) {
  const { id, image_url: imageUrl, name } = option;
  const sanitizedName = sanitize(name);
  const hasTooltip = !!option.tooltip_title;

  const buttonId = `option-button-${id}`;

  const container = (
    <div>
      <div className="option-tooltip-buttons">
        <button
          id={buttonId}
          className={`option-button ${isSelected ? 'selected' : ''}`}
          disabled={isDisabled}
          onClick={onClick}
        >
          {imageUrl !== '' && <img src={imageUrl} alt={sanitizedName} />}
          {imageUrl === '' && (
            <span
              className="option-button-title"
              dangerouslySetInnerHTML={{ __html: name }}
              title={sanitizedName}
            />
          )}
        </button>
        {hasTooltip && (
          <button className="tooltip-button" onClick={() => onClickTooltip(buttonId)}>
            <FontAwesomeIcon icon="info-circle" />
            <span className="screen-reader-text">Learn More</span>
          </button>
        )}
      </div>
      {imageUrl !== '' && (
        <span
          className="option-button-title"
          dangerouslySetInnerHTML={{ __html: name }}
          title={sanitizedName}
        />
      )}
    </div>
  );

  if (isDisabled) {
    const disabledContent = <span dangerouslySetInnerHTML={{ __html: disabledBy }} />;
    return (
      <Tippy content={<p>{disabledContent}</p>} theme="light" allowHTML>
        {container}
      </Tippy>
    );
  }

  return container;
}

export default OptionButton;
